

import { API, ProjectAPI, Tag, TagsAPI, AnyProject, AnyDesigner, Project, Nullable } from '@brg/api';
import { isNotEmptyArray, isNotEmptyString, isString } from '@brg/is';

export default class ProjectUtils {
    /**
     * Returns true if multiple authors in project
     * @param project
     */
    public static isMultipleAuthors(project: AnyProject): boolean {
        return project.coAuthors.length > 0;
    }

    public static getNullTagOption(lang: string): {
        label: string;
        value: string;
        color: string;
    } {
        return {
            label: lang.toLowerCase() === 'ru' ? 'Все' : 'All',
            value: 'DAFES',
            color: '',
        };
    }

    public static async getAllTagsOptions(
        entity: string,
        lang: string,
    ): Promise<Array<{ label: string; value: string; color: string }>> {
        const res = await API.Json(TagsAPI.GetTagsEntities({ entities: entity }));
        const l = API.lang<Tag[]>(res, lang);
        return [
            ProjectUtils.getNullTagOption(lang),
            ...l.map((value) => ({
                label: value.name,
                value: value.tagId,
                color: value.color,
            })),
        ];
    }

    /**
     * Returns true, if designer can change project
     * @param project
     * @param designer
     */
    public static isProjectOfMine(project: Nullable<AnyProject>, designer: Nullable<AnyDesigner>): boolean {
        return (
            !!project &&
            !!designer &&
            (project.author.accountId === designer.accountId ||
            (project.coAuthors as AnyDesigner[]).some((author: AnyDesigner) => author.accountId === designer.accountId))
        );
    }

    /**
     * Returns true, if designer can change project
     * @param project
     * @param id
     */
    public static isProjectOfMineById(project: Nullable<AnyProject>, id: string): boolean {
        return !!project && (project.author.accountId === id || (project.coAuthors as AnyDesigner[]).some((author: AnyDesigner) => author.accountId === id));
    }

    /**
     * Returns true if local project
     * @param project
     */
    public static isLocalProject(project: AnyProject): project is Project {
        return isString(project.title);
    }

    /**
     * Returns true, if project can be published
     * @param project
     * @param lang
     */
    public static isCanBePublished(project: AnyProject, lang: string): boolean {
        if (ProjectUtils.isLocalProject(project)) {
            return (
                isNotEmptyString(project.title) &&
                isNotEmptyString(project.projectId) &&
                isNotEmptyString(project.categoryID) &&
                isNotEmptyArray(project.tagsID) &&
                !!project.titleImage &&
                isNotEmptyString(project.titleImage.fileId)
            );
        } else {
            return ProjectUtils.isCanBePublished(API.lang(project, lang), lang);
        }
    }

    public static async updateStatus(projectId: string, status: number): Promise<unknown> {
        const projectSource = await API.Json(ProjectAPI.Get({ idProject: projectId }));
        projectSource.status = status;
        return await ProjectAPI.Update(projectSource);
    }

    public static async unpublish(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 0);
    }

    public static async publish(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 1);
    }

    public static async delete(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 2);
    }
}


import { API, ProjectAPI, Tag, TagsAPI, AnyProject, AnyDesigner, Project, Nullable } from '@brg/api';
import { isNotEmptyArray, isNotEmptyString, isString } from '@brg/is';

export default class ProjectUtils {
    /**
     * Returns true if multiple authors in project
     * @param project
     */
    public static isMultipleAuthors(project: AnyProject): boolean {
        return project.coAuthors.length > 0;
    }

    public static getNullTagOption(lang: string): {
        label: string;
        value: string;
        color: string;
    } {
        return {
            label: lang.toLowerCase() === 'ru' ? 'Все' : 'All',
            value: 'DAFES',
            color: '',
        };
    }

    public static async getAllTagsOptions(
        entity: string,
        lang: string,
    ): Promise<Array<{ label: string; value: string; color: string }>> {
        const res = await API.Json(TagsAPI.GetTagsEntities({ entities: entity }));
        const l = API.lang<Tag[]>(res, lang);
        return [
            ProjectUtils.getNullTagOption(lang),
            ...l.map((value) => ({
                label: value.name,
                value: value.tagId,
                color: value.color,
            })),
        ];
    }

    /**
     * Returns true, if designer can change project
     * @param project
     * @param designer
     */
    public static isProjectOfMine(project: Nullable<AnyProject>, designer: Nullable<AnyDesigner>): boolean {
        return (
            !!project &&
            !!designer &&
            (project.author.accountId === designer.accountId ||
            (project.coAuthors as AnyDesigner[]).some((author: AnyDesigner) => author.accountId === designer.accountId))
        );
    }

    /**
     * Returns true, if designer can change project
     * @param project
     * @param id
     */
    public static isProjectOfMineById(project: Nullable<AnyProject>, id: string): boolean {
        return !!project && (project.author.accountId === id || (project.coAuthors as AnyDesigner[]).some((author: AnyDesigner) => author.accountId === id));
    }

    /**
     * Returns true if local project
     * @param project
     */
    public static isLocalProject(project: AnyProject): project is Project {
        return isString(project.title);
    }

    /**
     * Returns true, if project can be published
     * @param project
     * @param lang
     */
    public static isCanBePublished(project: AnyProject, lang: string): boolean {
        if (ProjectUtils.isLocalProject(project)) {
            return (
                isNotEmptyString(project.title) &&
                isNotEmptyString(project.projectId) &&
                isNotEmptyString(project.categoryID) &&
                isNotEmptyArray(project.tagsID) &&
                !!project.titleImage &&
                isNotEmptyString(project.titleImage.fileId)
            );
        } else {
            return ProjectUtils.isCanBePublished(API.lang(project, lang), lang);
        }
    }

    public static async updateStatus(projectId: string, status: number): Promise<unknown> {
        const projectSource = await API.Json(ProjectAPI.Get({ idProject: projectId }));
        projectSource.status = status;
        return await ProjectAPI.Update(projectSource);
    }

    public static async unpublish(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 0);
    }

    public static async publish(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 1);
    }

    public static async delete(projectId: string): Promise<unknown> {
        return ProjectUtils.updateStatus(projectId, 2);
    }
}
